import {
  CalendarDays, Camera, ClipboardList,
  DollarSign, Home, LayoutDashboard, Megaphone, Trophy, Users,
  Database, Dumbbell, Crown, MessageSquare, Receipt
} from "lucide-react";
import { rolePermissions } from "./data";

// Phase 3 — Grouped nav. Each item now declares a `group` so the sidebar
// can render them under collapsible section headers ("My Stuff", "Team",
// "Club", "Admin"). Groups + their order are defined below in NAV_GROUPS.
// The flat `nav` array (legacy consumers) is preserved in source order.
export const nav = [
  // MY STUFF
  { key: "dashboard",     label: "Dashboard",      icon: LayoutDashboard, group: "my" },
  { key: "messages",      label: "Messages",       icon: MessageSquare,   group: "my" },
  // Phase 4 — Splitwise-style personal shared expenses. Access is scoped
  // in the backend to payer + participants; no admin bulk view.
  { key: "splits",        label: "Splits",         icon: Receipt,         group: "my" },
  // Notifications removed from sidebar nav — surfaced via the top-left
  // bell icon in each shell's topbar. Module.jsx still routes the
  // `notifications` key in case anything deep-links to it.

  // TEAM
  { key: "schedule",      label: "Schedules",      icon: CalendarDays,    group: "team" },
  // Availability is a cross-match matrix for captains to plan lineups.
  // It's reached from a tab on the Schedules page (see Schedules.jsx),
  // not from the sidebar — regular players don't need a second RSVP
  // surface next to the one already on Schedule cards.
  { key: "squad",         label: "Squads",         icon: ClipboardList,   group: "team" },
  { key: "practice",      label: "Practice",       icon: Dumbbell,        group: "team" },
  { key: "rankings",      label: "Rankings",       icon: Crown,           group: "team" },

  // CLUB
  { key: "members",       label: "Members",        icon: Users,           group: "club" },
  { key: "groups",        label: "Groups",         icon: Home,            group: "club" },
  { key: "teams",         label: "Teams",          icon: Trophy,          group: "club" },
  { key: "announcements", label: "Announcements",  icon: Megaphone,       group: "club" },
  { key: "media",         label: "Gallery",        icon: Camera,          group: "club" },
  // League is no longer a nav item in Gabruz Universe — it has its own
  // workspace / shell (see LeagueShell.jsx). Users with committee-tier
  // roles switch into it from the topbar overflow / mobile sheet.

  // ADMIN
  { key: "finance",       label: "Finance",        icon: DollarSign,      group: "admin" },
  { key: "admin",         label: "Admin",          icon: Database,        group: "admin" }
];

// Ordered group definitions for the sidebar renderer.
export const NAV_GROUPS = [
  { key: "my",    label: "My Stuff" },
  { key: "team",  label: "Team" },
  { key: "club",  label: "Club" },
  { key: "admin", label: "Admin" }
];

export const can = (user, key) =>
  user.roles.some(r => rolePermissions[r]?.includes(key));
